module.exports = __webpack_public_path__ + "static/media/doument_pending.5e0a1023.svg";